import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="w-full px-4 sm:px-8 lg:px-20 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-[#3782df] rounded-lg flex items-center justify-center">
                <i className="ri-code-s-slash-line text-xl text-white"></i>
              </div>
              <span className="text-xl font-bold">LumanyiTech</span>
            </div>
            <p className="text-sm text-gray-400 mb-4 leading-relaxed">
              Empowering businesses through innovative technology solutions and strategic partnerships.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/agribusiness" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                  Agribusiness
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-base font-bold mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                  Website Development
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                  Graphic Design
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                  Data Analytics
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                  Business Solutions
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                  FinTech Solutions
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-base font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-[#3782df] mt-0.5"></i>
                <a href="tel:+254712345678" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                  +254 712 345 678
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-[#3782df] mt-0.5"></i>
                <a href="mailto:info@lumanyitech.co.ls" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                  info@lumanyitech.co.ls
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-[#3782df] mt-0.5"></i>
                <span className="text-sm text-gray-400 leading-relaxed">
                  Maseru<br />
                  Tlasa Mabathoana High School<br />
                  Office No: 2
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-400 text-center sm:text-left">
              © 2026 LumanyiTech. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-6">
              <Link to="/privacy" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-sm text-gray-400 hover:text-[#3782df] transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}